import axios, { AxiosResponse } from 'axios';

const BASE_URL = 'https://sodastreamapi.azurewebsites.net/address';

export interface Address {
  id: number;
  user_id?: number;  
  city: string;
  province: string;
  country: string;
  postal_code: string;
  address_1:string
  address_type:string
  building_type:string
  unit_number: string,
  block_number: string
  suburb:string;
  block_name:string
  place_id:string;
  special_instruction:string;
  longitude:number;
  latitude:number;
  building_type_name:string;
  street_number:string;
  street_name:string;
  building_name_or_number:string;
  unit_name_or_number:string;
  block_name_or_number:string;
  business_park_or_residential_complex_name:string;
  
  

}

class AddressService {


  async selectAddress(userId: number, addressId:number): Promise<{ data: Address | null; error: string | null }> {
    try {
      const response = await axios.put(`${BASE_URL}/select-address/${userId}/${addressId}`);
      
      if (response.status >= 200 && response.status < 300) {
        const address = response.data || null; 
        return { data: address, error: null };
      }
  
      return { data: null, error: `Error updating  address - ${response.status}: ${response.statusText}` };
    } catch (error: any) {
      const errorMsg = error.response ? error.response.data : error.message;
      return { data: null, error: errorMsg };
    }
  }

  async editAddress(
    addressId: number,
    updatedAddressData: Address
  ): Promise<{ data: any| null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.put(`${BASE_URL}/${addressId}`, updatedAddressData);
      if (response.status >= 200 && response.status < 300) {
        const updatedProduct: Address = response.data;

        return { data: updatedProduct, error: null };
      } else {
        const error = `Error updating address - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error updating address:", error.message);
     
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }


  
 
  async getAllAddresses(): Promise<{ data: Address[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<Address[]> = await axios.get(BASE_URL);
      if (response.status >= 200 && response.status < 300) {
        const addresses: Address[] = response.data;

        return { data: addresses, error: null };
      } else {
        const error = 'Error fetching addresses';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error fetching addresses:', error);
      return { data: null, error: error.message };
    }
  }

  async getAddressById(addressId: number): Promise<{ data: Address | null; error: string | null }> {
    try {
      const response: AxiosResponse<Address> = await axios.get(`${BASE_URL}/${addressId}`);
      if (response.status >= 200 && response.status < 300) {
        const address: Address = response.data;
 
        return { data: address, error: null };
      } else {
        const error = 'Error fetching address by ID';
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error fetching address by ID:', error);
      return { data: null, error: error.message };
    }
  }

  async createAddress(addressData: Address): Promise<{ data: Address | null; error: string | null }> {
    try {
      const response: AxiosResponse<Address> = await axios.post(BASE_URL, addressData);
      if (response.status >= 200 && response.status < 300) {
        const createdAddress: Address = response.data;

        return { data: createdAddress, error: null };
      } else {
        const error = `Error creating address - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error creating address:', error.message);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
        console.error('Response headers:', error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }



  async deleteAddress(addressId: number): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.delete(`${BASE_URL}/${addressId}`);
      if (response.status >= 200 && response.status < 300) {

        return { data: response.data, error: null };
      } else {
        const error = `Error deleting address - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error deleting address:', error.message);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
        console.error('Response headers:', error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async getAddressByUserId(userId: number): Promise<{ data: Address | null; error: string | null }> {
    try {
      const response = await axios.get(`${BASE_URL}/user/${userId}`);
      
      if (response.status >= 200 && response.status < 300) {
        const address = response.data || null; 
        return { data: address, error: null };
      }
  
      return { data: null, error: `Error fetching address - ${response.status}: ${response.statusText}` };
    } catch (error: any) {
      const errorMsg = error.response ? error.response.data : error.message;
      return { data: null, error: errorMsg };
    }
  }
  async getPrimaryAddressByUserId(userId: number): Promise<{ data: Address | null; error: string | null }> {
    try {
      const response = await axios.get(`${BASE_URL}/user/primary/${userId}`);


      
      if (response.status >= 200 && response.status < 300) {
        const address = response.data || null; 

        return { data: address, error: null };
      }
  
      return { data: null, error: `Error fetching address - ${response.status}: ${response.statusText}` };
    } catch (error: any) {
      const errorMsg = error.response ? error.response.data : error.message;
      return { data: null, error: errorMsg };
    }
  }

   async updateSpecialInstruction(addressId: number, specialInstruction: string): Promise<{ data: Address | null; error: string | null }> {
    try {
      const response: AxiosResponse<Address> = await axios.put(`${BASE_URL}/${addressId}/special-instruction`, { special_instruction: specialInstruction });
      
      if (response.status >= 200 && response.status < 300) {
        const updatedAddress: Address = response.data;

        return { data: updatedAddress, error: null };
      } else {
        const error = `Error updating special instruction - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error('Error updating special instruction:', error.message);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
        console.error('Response headers:', error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  
  }

const addressServiceInstance = new AddressService();
export default addressServiceInstance;
